import { createSlice } from '@reduxjs/toolkit';
import translate from '@translate';
import {
    ImportOrderImportFilesResData,
    OrdersImportStateType,
    ValidateFileImportResType,
} from 'src/types/ordersImport';

const initialState: OrdersImportStateType = {
    files: [],
    loading: false,
};
export const ordersImportSlice = createSlice({
    name: 'ordersImport',
    initialState,
    reducers: {
        addFile: (state, action) => {
            state.files = [...state.files, { file: action.payload.file, loading: true }];
        },
        deleteFile: (state, action) => {
            state.files = state.files.filter((file) => file.file.name !== action.payload.name);
        },
        validateFileImportFetch: (state, action) => {},
        validateFileImportFetchSuccess: (state, action) => {
            const orders: ValidateFileImportResType = action.payload.validation;
            state.files = state.files.map((file) => {
                if (file.file.name === action.payload.file.name) {
                    file.loading = false;
                    file.validation = {
                        createCount: orders.filter((order) => !order.ID).length,
                        orders: orders,
                        updateCount: orders.filter((order) => !!order.ID).length,
                    };
                }
                return file;
            });
        },
        validateFileImportFetchFailure: (state, action) => {
            state.files = state.files.map((file) => {
                if (file.file.name === action.payload.file.name) {
                    file.loading = false;
                    file.error = translate('ordersImport.incorrectFile');
                }
                return file;
            });
        },
        importFilesFetch: (state) => {
            state.loading = true;
        },
        importFilesFetchSuccess: (state, action) => {
            state.loading = false;
            state.files = state.files = state.files.map((file) => {
                file.imported = true;
                file.validation?.orders.map((order) => {
                    const importedData = action.payload.imported.find(
                        (imported: ImportOrderImportFilesResData) => imported.ESHOP_ORDER_ID === order.ESHOP_ORDER_ID
                    );
                    if (importedData) {
                        order.result = importedData.result;
                    }
                });
                return file;
            });
        },
        importFilesFetchFailure: (state, action) => {
            state.loading = false;
        },
        clearOrdersImport: () => initialState,
    },
});

export const {
    addFile,
    deleteFile,
    validateFileImportFetch,
    validateFileImportFetchSuccess,
    validateFileImportFetchFailure,
    importFilesFetch,
    importFilesFetchSuccess,
    importFilesFetchFailure,
    clearOrdersImport,
} = ordersImportSlice.actions;

export default ordersImportSlice.reducer;
